module.exports = __webpack_public_path__ + "static/media/uj_szerzkot1.0af6bc03.jpg";